import React from "react";
import PageHeader, { LegalBody } from "../components/PageHeader";
import { COMPANY } from "../mock/data";

export default function Disclaimer() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Disclaimer" subtitle={`Important information about the use of ${COMPANY.brand} products and ${COMPANY.website}.`} />
      <LegalBody>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <h2>General Information</h2>
        <p>The information provided on {COMPANY.website} is for general informational purposes only. All information on the site is provided in good faith by {COMPANY.legalName}, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.</p>

        <h2>No Professional Advice</h2>
        <p>Content on this site is not intended to be a substitute for professional cybersecurity, legal, financial, or medical advice. Always seek the advice of qualified professionals with any questions you may have.</p>

        <h2>Security Product Disclaimer</h2>
        <p>While {COMPANY.brand} employs industry-leading detection technologies, no antivirus or security product can guarantee 100% protection against every threat. We continuously improve our detection, but users should also follow best security practices such as using strong passwords and keeping software updated.</p>

        <h2>External Links</h2>
        <p>The site may contain links to third-party websites. We do not investigate or endorse the content of such sites and are not responsible for their accuracy or reliability.</p>

        <h2>Trademarks</h2>
        <p>{COMPANY.brand} and the {COMPANY.brand} logo are trademarks of {COMPANY.legalName}. All other trademarks are the property of their respective owners.</p>

        <h2>Contact</h2>
        <p>Questions about this Disclaimer? Contact us at <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</p>
      </LegalBody>
    </>
  );
}
